// extracted by mini-css-extract-plugin
export default {"title":"companyTitles_title__ZL3OY","titleCirclesView":"companyTitles_titleCirclesView__CuEtO"};